import {ethers} from "ethers";
import {ERC721_ABI} from "../abi/erc721-abi";

export async function getCollectionNameFromAddress(collectionAddress: string, provider: any) {
    let checksumAddress = ethers.utils.getAddress(collectionAddress);
    const nftContract = new ethers.Contract(checksumAddress, ERC721_ABI, provider);
    return await nftContract.name();
}